import React, { ReactElement } from 'react';
import Modal from 'react-modal';
import { Slider } from '../slider/Slider';
import IconExit from '../../../../../../assets/svg/icon-exit.svg';
import { styles } from './ImageModal.css';

export type ImageModalProps = {
  sortedImages: Array<string | ReactElement>;
  title: string;
  toggleModal: (...args: boolean[]) => void;
  showModal: boolean;
  initialSlide: number;
};

if (typeof document !== 'undefined' && document.getElementById('ModalContainer')) {
  Modal.setAppElement('#ModalContainer');
} else if (typeof document !== 'undefined') {
  // Fallback for environments like Chromatic where the container may not exist during story import
  Modal.setAppElement(document.body);
}

export const ImageModal = ({
  sortedImages,
  title,
  toggleModal,
  showModal,
  initialSlide = 0,
}: ImageModalProps): JSX.Element => {
  return (
    <Modal
      isOpen={showModal}
      contentLabel="Address delete confirm dialog"
      onRequestClose={() => toggleModal(false)}
      className={styles.modalDialog}
      portalClassName="modal__overlay"
      bodyOpenClassName="modal__body--open"
      htmlOpenClassName="modal__html--open"
      parentSelector={() => document.getElementById('ModalContainer')}
    >
      <button className={styles.close} title="Close" onClick={() => toggleModal(false)}>
        <IconExit />
      </button>
      <Slider
        className={styles.slider}
        sortedImages={sortedImages}
        title={title}
        arrows={true}
        initialSlide={initialSlide}
        imageWidth={65}
        imageSizes="(max-width: 991px) 100vw, 1000px"
      />
    </Modal>
  );
};
